import React from 'react'
import { Alert } from 'antd'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import { getIntegrationPlatformName } from '@vacationtracker/shared/functions/get-integration-platform-name'

import { Platform } from '@vacationtracker/shared/types/core-event'

interface IAutoSyncNoticeProps {
  platform: Platform
}

const AutoSyncNotice = ({ platform }: IAutoSyncNoticeProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const platformName = getIntegrationPlatformName(platform)

  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message={formatMessage({ id: 'general.importUsersAutomaticallyInfo' }, { platform: platformName })}
      description={<Link to="/app/settings/general">{formatMessage({ id: 'components.importUsersForm.autoSyncManageSettings' })}</Link>}
    />
  )
}

export default AutoSyncNotice
